<div class="container-fluid padMob webViewBack padZero" style="padding-left: 10px; padding-right: 10px;">
    <div class="row mobView bg">
        <!-- Header -->
        <div class="col-md-12 col-12 col-sm-12 bgWhite padHeder divHeader"  style="padding-bottom: 0px;">
            <div class="col-md-8 col-8 col-sm-8 padZero" style="display: inline-block;padding: 0px;">
                <span style="font-size: 22px; margin-right: 10px; display: inline-block; cursor: pointer;" class="mobView" (click)="goBack();"><i class="fa fa-chevron-left"></i></span>
                <h4 class="modalHeader" style="display: inline-block; color: #555;">BOM Items </h4> 
            </div>
            <div class="col-md-4 col-4 col-sm-4" style="padding: 0px; display: inline-block; text-align: right;">
                <span>
                    <span class="orangeButton" style="padding: 5px 9px !important;" (click)="openItemSelect(selectItem)">
                        <i class="zmdi zmdi-plus" aria-hidden="true"></i>
                    </span>
                    <span style="border-radius: 50%; cursor: pointer; bottom: 5px; padding: 12px; font-size: 11px; display: inline !important; margin-left: 10px; display: none !important;" class="webView closeMdl" (click)="goBack();">
                        <i class="zmdi zmdi-close"></i>
                    </span>
                </span>
            </div>
        </div>
        <!-- Body -->
        <div class="col-md-12 col-12 col-sm-12 headerPadding DivPad">            
            <!-- Product Name -->
            <div class="col-md-12 col-12 col-sm-12 bgWhite" style="padding: 5px 15px;">
                <div class="col-md-12 col-12 col-sm-12" style="padding-left: 0px;">
                    <span style="font-size: 18px; color: #333;">
                        {{prductData.productName}}
                    </span>  
                </div>
                <div class="col-md-12 col-sm-12 col-xs-12 pad0" style="margin-top: 10px;">
                    <span class="dtlBadge darkBlue" *ngIf="isRateView">
                        Total Cost  <span class="dtlVal">₹ {{totalCost | lacFormat}}</span>
                    </span> 
                </div>
            </div>           

            <!-- Item List -->
            <div class="col-md-12 col-12 col-sm-12 pad0">
                <div class="col-md-12 col-12 col-sm-12 pad0" style="padding: 0px 15px;" *ngIf="prductData.bom.length > 0">
                    <div *ngFor="let P of prductData.bom; let i = index" style="padding: 10px; border: 1px solid #f0f0f0; background-color: #fff; border-radius: 3px; margin-bottom: 5px;">                    
                        <div class="col-md-12 col-12 col-sm-12 pad0">
                            <!-- <div class="col-md-7 col-sm-7 col-7 pad0 font14 inLneBlk"
                                style="vertical-align: -webkit-baseline-middle;">
                                <h4 class="font14" style="margin-top: 10px;"> {{P.productName}}
                                </h4>
                                <h4 class="font14" style="margin-bottom: 0px;color: #777;">{{P.productCode}}</h4>
                            </div>
                            <div class="col-md-5 col-sm-5 col-5 inLneBlk pad0" style="text-align: right;">
                                <span class="inLneBlk" style="width: min-content;"> <input type="text" id="txtItem"
                                        class="form-control " tabindex="1"  [(ngModel)]="P.ReqdQty"  placeholder="Qty" title="Item Name" captalize-first
                                        style=" height: 20px;padding: 15px; width: 80px; background: inherit; text-align: right;"
                                        maxlength="50" />
                                </span>
                                <span class="inLneBlk font14"> {{P.Unit}}</span>
                            </div> -->
                            <div>
                                <div class="col-md-7 col-7 col-sm-7 pad0 inLneBlk">
                                    <span class="font14">{{P.productName}}</span>
                                </div>
                                <div class="col-md-5 col-5 col-sm-5 pad0 inLneBlk txtRight">
                                    <span class="lableBtnGray brdrRadius3" style="padding: 1px 6px; font-size: 13px; position: relative; top: -5px; right: -5px;">
                                        <i class="fa fa-trash-o" (click)="removeBOM(i)"></i>
                                    </span>
                                </div>
                            </div>
                            <div>
                                <div class="col-md-7 col-7 col-sm-7 pad0 inLneBlk">
                                    <span class="font12" style="margin-bottom: 0px;color: #777;"># {{P.productCode}}</span>
                                </div>
                                <div class="col-md-5 col-5 col-sm-5 pad0 inLneBlk" style="text-align: right;">
                                    <span class="inLneBlk" style="width: min-content;"> 
                                        <input type="text" id="txtItem"
                                            class="form-control bzInput bzInputPad" tabindex="1"  [(ngModel)]="P.ReqdQty"  placeholder="Qty" (keyup)="prcisionCheck(P);"
                                            style=" height: 25px; width: 80px; text-align: right;" 
                                            maxlength="50" />
                                    </span>
                                    <span class="inLneBlk font12" style="margin-left: 3px;"> {{P.Unit}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div  class="bgWhite" style="padding-top: 15px;" *ngIf="prductData.bom.length == 0">
                    <div class="nrf brdrRadius3" (click)="openItemSelect(selectItem);" style="margin-left: 15px; cursor: pointer;">
                        Click here to add a raw material.
                    </div>
                </div>

                <!-- Stage Save -->
                <div class="col-md-12 col-12 col-sm-12 bgWhite" style="padding-top: 10px;">
                    <div class="btn btn-darkGreen brdrRadius3" (click)="fn_saveBOM();" style="padding: 5px 12px; line-height: 18px; margin-right: 10px;">
                        <i class="fa fa-check"></i> Save
                    </div>
                    <div class="btn-mdlClose brdrRadius3" (click)="goBack();">
                        <i class="fa fa-close"></i> Close
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="webView" style="width: 100%;">
        <div style="color: #e88421; font-size: 16px; font-weight: bold;">
            <span>Bill of Materials ({{prductData.bom.length}})</span>
            
            <span class="orangeButton brdrRadius3" title="Copy BOM" style="float: right; font-size: 15px; cursor: pointer;" *ngIf="(!isEdit) && (prductData.bom.length == 0) && !isProjectType" (click)="copyFromProduct()"><i class="zmdi zmdi-copy"></i></span>
            <span class="lableBtnOrange brdrRadius3" title="Add BOM" style="float: right; font-size: 15px; cursor: pointer; padding: 2px 9px;" *ngIf="isEdit" (click)="openItemSelect(selectItem)"><i class="zmdi zmdi-plus"></i></span>
            <span class="orangeButton brdrRadius3" title="BOM Print" *ngIf="!isEdit && right.InvMstrs && prductData.bom.length > 0" style="float: right; padding: 2px 7px; cursor: pointer; display:inline-block; font-size: 15px;" (click)="openBOMPrint()">
                <i class="zmdi zmdi-print" aria-hidden="true"></i>
            </span>
            <span class="orangeButton brdrRadius3" title="Edit BOM" style="float: right; font-size: 15px; cursor: pointer; margin-right: 5px; padding: 2px 7px;" *ngIf="!isEdit && right.InvMstrs && !isProjectType" (click)="fn_changeBOMQty();"><i class="fa fa-pencil"></i></span>
            <span *ngIf="!isEdit && right.InvMstrs" (click)="importBOM()" class="btn orangeButton" title="Import BOM"
                style="cursor: pointer; margin-left: 7px; line-height: 19px; padding: 5px 10px !important; float: right; margin-right: 5px; height: 30px !important; display: inline-flex; align-items: center; justify-content: center;">
                <i class="zmdi zmdi-arrow-left-bottom" aria-hidden="true" style="font-weight: bold; font-size: 16px;"></i> 
                <span style="font-size: 14px; margin-left: 5px;">Import</span>
            </span>


            <!-- <span style="float: right; font-size: 20px; cursor: pointer;" (click)="fn_OpenBOM();" class="mobView"><i class="zmdi zmdi-plus"></i></span> -->
        </div>
        <div *ngIf="isRateView" style="font-size: 12px;">
            <span>
                (Total Cost  
                <span style="color: #333; font-weight: bold;">₹ {{totalCost | lacFormat}}</span>) 
            </span>
        </div>
        <div *ngIf="prductData.bom.length > 0">
            <!-- <div class="marginTp" *ngFor="let P of prductData.bom; let i = index">                    
                <div class="col-md-12 col-12 col-sm-12 pad0">
                    <div>
                        <div class="col-md-7 col-7 col-sm-7 pad0 inLneBlk">
                            <span class="font14">{{P.productName}}</span>
                        </div>
                        <div class="col-md-5 col-5 col-sm-5 pad0 inLneBlk txtRight"> -->
                            <!-- <span class="inLneBlk font14" style="margin-right: 5px;"> {{P.Price}}</span> -->
                            <!-- <span class="inLneBlk" style="width: min-content;"> 
                                <input type="text" id="txtItem"
                                class="form-control " tabindex="1" [(ngModel)]="P.ReqdQty"  placeholder="Qty" (keyup)="prcisionCheck(P);"
                                style=" height: 20px;padding: 15px; width: 80px; background: inherit; text-align: right;"
                                maxlength="50" *ngIf="isEdit" />
                                <span *ngIf="!isEdit" style="margin-right: 5px;">{{P.ReqdQty}}</span>
                            </span>
                            <span class="inLneBlk font14" style="margin-right: 5px;"> {{P.Unit}}</span>
                            <span class="lableBtnGray brdrRadius3" style="padding: 1px 8px 1px;" *ngIf="isEdit"><i class="fa fa-trash-o" (click)="removeBOM(i)"></i></span>
                        </div>
                    </div>
                </div>
            </div> -->

            <table class="table table-bordered ngTable brdrRadius3 table-bordered"
            style="width: 100%; margin-bottom: 10px; margin-top: 10px; background-color: white;">
            <thead style="font-size: 13px; cursor: pointer;">
                <tr>
                    <th style="width: 30%; padding: 5px; border-bottom-width: 1px;">Item</th>
                    <th *ngIf="isRateView" style="width: 18%; text-align: right; padding: 5px; border-bottom-width: 1px;">Rate (₹)</th>
                    <th style="width: 15%; text-align: right; padding: 5px; border-bottom-width: 1px;">Qty</th>
                    <th style="width: 5%; text-align: left;padding: 5px; border-bottom-width: 1px;">Unit</th>
                    <th *ngIf="isEdit" style="width: 3%; text-align: left;padding: 5px; border-bottom-width: 1px;"></th>
                </tr>
            </thead>

            <tbody>
                <tr *ngFor="let P of prductData.bom; let i = index" style="vertical-align: top;cursor: pointer;font-size: 13px; border-bottom: 1px solid #dee2e6;">
                    <td style="padding: 5px; vertical-align: top;">
                        <div style="display: inline-block; font-size: 13px; padding: 0px 0px 5px;">
                            <span> {{P.productName}} </span>
                            </div>
                    </td>
                    <!-- <td *ngIf="isRateView" style="text-align: right;vertical-align: middle;padding: 5px;">₹ {{P.Price | lacFormat : 0 ? P.Price:'0'}}</td> -->
                    <td *ngIf="isRateView" style="text-align: right;vertical-align: top;padding: 5px;">
                        <span *ngIf="myCurrency.code == 'INR'">{{P.purchRate | lacFormat}}</span>       
                        <span *ngIf="myCurrency.code != 'INR'"> {{P.purchRate | currency}}</span>
                    </td>
                    <td style="text-align: right; vertical-align: top; padding: 5px;">
                        <span class="inLneBlk" style="width: min-content;"> 
                            <input type="text" id="txtItem"
                            class="form-control " tabindex="1" [(ngModel)]="P.ReqdQty"  placeholder="Qty" (keyup)="prcisionCheck(P);"
                            style=" height: 20px;padding: 15px; width: 80px; background: inherit; text-align: right;"
                            maxlength="50" *ngIf="isEdit" />
                            <span *ngIf="!isEdit" style="margin-right: 5px;">{{P.ReqdQty}}</span>
                        </span>
                    </td>
                    <td style="text-align: left;vertical-align: top;padding: 5px;">{{P.Unit ? P.Unit:'0'}}</td>
                    <td class="lableBtnGray brdrRadius3" style="padding: 1px 8px 1px; margin: 8px 1px 5px 5px; vertical-align: top;" *ngIf="isEdit"><i class="fa fa-trash-o" (click)="removeBOM(i)"></i></td>
                </tr>
            </tbody>
            </table>


            <!-- Stage Save -->
            <div class="col-md-12 col-12 col-sm-12" style="padding-top: 10px; padding-left: 0px;">
                <div class="btn darkGreenButton brdrRadius3" style="line-height: normal;font-size: 13px; padding: 2px 7px 2px;" *ngIf="isEdit" (click)="fn_saveBOM();">
                    <i class="fa fa-check"></i> Save
                </div>
            </div>
        </div>

        
        <div *ngIf="prductData.bom.length == 0 && !isProjectType">
            <div class="nrf  brdrRadius3" (click)="openItemSelect(selectItem);" style="margin-top: 15px; font-size: 13px; cursor: pointer;">
                Click here to add a raw material.
            </div>
        </div>
    </div>
</div>

<!-- Item Modal -->
<ng-template #selectItem let-modal>
    <button id="closeModalButton" data-toggle="modal" [hidden]="true"       
    data-target="#myModal" class="btn btn-default" (click)="closeModal()">Close</button>
    <app-multiple-select-item></app-multiple-select-item>
</ng-template>